import { useState, useEffect } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { NewsletterSignup } from "@/components/newsletter/NewsletterSignup";
import { Flame } from "lucide-react";

const KEY = "nk_newsletter_v1";
const IMG = "https://customer-assets-jai6qajn.emergentagent.net/job_novemberkasan-live/artifacts/i5hw6p7x_Novemberka%CC%8Asan%202025-17.webp";

export const NewsletterModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(KEY)) return;
    const t = setTimeout(() => setOpen(true), 9000);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setOpen(false);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) dismiss(); }}>
      <DialogContent className="max-w-md border-amber-500/20 bg-[#0F1114] p-0 text-white overflow-hidden" data-testid="newsletter-modal">
        <div className="relative h-32">
          <img src={IMG} alt="" className="h-full w-full object-cover opacity-50" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0F1114] to-transparent" />
        </div>
        <div className="relative -mt-10 px-7 pb-7">
          <div className="inline-flex items-center gap-2 font-mono text-[11px] uppercase tracking-widest text-amber-500">
            <Flame className="w-4 h-4" /> Inför årets kåsa
          </div>
          <h3 className="mt-2 font-display text-3xl font-black uppercase leading-tight text-white">Missa inget</h3>
          <p className="mt-2 text-sm text-white/60">Anmäl dig för nyhetsbrev och uppdateringar inför Novemberkåsan 2026 – anmälan, startlistor, program och mer.</p>
          <div className="mt-5"><NewsletterSignup source="popup" onSuccess={() => localStorage.setItem(KEY, "1")} /></div>
          <button onClick={dismiss} className="mt-4 w-full text-center text-xs text-white/35 hover:text-white/60" data-testid="newsletter-dismiss">Inte nu</button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
